export default __webpack_public_path__ + "static/media/Icons_Electric Icon.0a25ac0a.svg";